import type { HTMLAttributes, ReactNode } from 'react'

import styles from './Card.module.css'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padded?: boolean
}

export function Card({ padded = false, className = '', ...props }: CardProps) {
  return <div className={`${styles.card} ${padded ? styles.padded : ''} ${className}`} {...props} />
}

export interface CardHeadProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode
  subtitle?: ReactNode
  action?: ReactNode
  plain?: boolean
}

export function CardHead({ title, subtitle, action, plain = false, className = '', ...props }: CardHeadProps) {
  return (
    <div className={`${styles.head} ${plain ? styles.plain : ''} ${className}`} {...props}>
      <h3 className={styles.title}>
        {title}
        {subtitle ? <span className={styles.subtitle}>{subtitle}</span> : null}
      </h3>
      {action}
    </div>
  )
}
